module.exports = __webpack_public_path__ + "static/media/america-tigres.2a0bfd88.mp4";